import React from 'react';
import clsx from 'clsx';
import Button from "../../Button";
import Guideline from "../../Guideline";

import { createStyles } from "./styles";

var ContributionOption = function ContributionOption(props) {
  var
    children =





    props.children,guidelines = props.guidelines,_props$showGuidelines = props.showGuidelinesByDefault,showGuidelinesByDefault = _props$showGuidelines === void 0 ? false : _props$showGuidelines,disclaimer = props.disclaimer,onClick = props.onClick,isBtnActive = props.isBtnActive;

  var classes = createStyles();
  var activeBtnClasses = clsx(classes.contributionBtn, classes.activeContributionBtn);
  var defaultBtnClasses = clsx(classes.contributionBtn, classes.defaultContributionBtn);

  return /*#__PURE__*/(
    React.createElement("div", { className: classes.contributionBtnWrapper }, /*#__PURE__*/
    React.createElement(Button, {
      type: "opaque",
      color: isBtnActive ? 'primary' : 'default',
      className: isBtnActive ? activeBtnClasses : defaultBtnClasses,
      onClick: onClick },

    children),

    disclaimer && /*#__PURE__*/React.createElement("p", { className: classes.contributionDisclaimer }, disclaimer),
    guidelines && /*#__PURE__*/
    React.createElement(Guideline, {
      text: guidelines,
      showGuidelinesByDefault: showGuidelinesByDefault,
      className: classes.contributionBtnGuidelines,
      width: "65%" })));




};

export default ContributionOption;
//# sourceMappingURL=index.js.map